<div class="payment-info">
    @if(showHeader) {
        <div class="header">{{ 'initLogin.entryFeePaymentHeader' | translate }}</div>
    }
    <div class="payment-layout">
        <div class="qr-container">
            <liberro-qr-payment
                [accountNumber]="depositInfo.accountNumber"
                [variableSymbol]="depositInfo.variableSymbol"
                [specificSymbol]="specificSymbol"
                [bankCode]="depositInfo.bankCode"
                [currency]="depositInfo.currency"
                [amount]="amount"
            ></liberro-qr-payment>
        </div>
        <div class="payment-values">
            <liberro-payment-row [translateKey]="'accountNumber'" [value]="depositInfo.accountNumber + '/' + depositInfo.bankCode"></liberro-payment-row>
            <liberro-payment-row [translateKey]="'variableSymbol'" [value]="depositInfo.variableSymbol"></liberro-payment-row>
            <liberro-payment-row [translateKey]="'specificSymbol'" [value]="specificSymbol"></liberro-payment-row>
            <liberro-payment-row [translateKey]="'amount'" [value]="amount | price:depositInfo.currency"></liberro-payment-row>
        </div>
    </div>
</div>
